
export const treeRecursionMap = (tree, map, labelValue = {label: 'label', value: 'value', children: 'children'}) => {
    tree.forEach(node => {
        map[node[labelValue.value]] = node[labelValue.label]
        if (node[labelValue.children] && node[labelValue.children].length > 0) {
            treeRecursionMap(node[labelValue.children], map)
        }
    })
}

export default {
    props: {
        labelValue: {
            type: Object,
            default: () => ({label: 'label', value: 'value', children: 'children'})
        },
    },
    methods: {
        treeRecursionMap,
        getTextByMap (value, map, textSeparator = '/') {
            if (!value && value !== 0) return ''
            const codeArr = String(value).split(textSeparator)
            const textArr = codeArr.map(c => (map[c] || c))
            return textArr.join(textSeparator)
        }
    }
}
